/* jshint esversion: 6 */
import utils from '../libs/utils';
import { getCartList,getPilotCityCartList } from '@/libs/api'

const group = 'cart';

const model = {
  CART_LIST: [],
  CART_LIST_PILOT_CITY: [],
};

export const types = utils.genTypes(model, group);
export const state = utils.genState(model, group);
export const getters = utils.genGetters(types);
export const mutations = utils.genMutations(types);

mutations[types.RESET] = (s) => {
  Object.keys(s).forEach((key) => {
    s[key] = state[key];
  });
};



export const actions = {
  // 选项列表
  [types.CART_LIST](store, query) {
    return getCartList(query, 'jsonCallback').then(res => {
      return res;
    })
  },
  [types.CART_LIST_PILOT_CITY](store, query) {
    return getPilotCityCartList(query, 'jsonCallback').then(res => {
      return res;
    })
  },
}